import Button from 'react-bootstrap/Button'
import React from 'react'
import { useNavigate } from 'react-router-dom'

const Home = () => {
  const history = useNavigate()

  return (
    <div
      className='position-fixed  w-100 h-100 top-50 start-50 translate-middle z-index-2 bg-opacity-75'
      style={{
        zIndex: '3000',
        backgroundColor: 'rgba(120,120,120,0.45)'
      }}
    >
      <div className='d-flex  flex-column align-items-center justify-content-center h-100 '>
        <Button
          type='button'
          className='btn btn-secondary m-1  btn-lx '
          onClick={() => history('/recepcionar-caso')}
        >
          Recepcionar Caso
        </Button>

        <Button
          type='button'
          onClick={() => history('/asignar-responsable')}
          className='btn btn-warning m-1  btn-lx'
        >
          Asignar Responsable
        </Button>

        <Button
          type='button'
          onClick={() => history('/antecedentes-liquidacion')}
          className='btn btn-warning m-1  btn-lx'
        >
          Atecendentes Liquidación
        </Button>
      </div>
    </div>
  )
}

export default Home
